import filter from 'lodash/filter';
import map from 'lodash/map';

(function IIFE() {
    'use strict';

    /////////////////////////////

    /* @ngInject */
    function WidgetLinksController($scope, Translation, Utils) {
        var vm = this;

        /////////////////////////////
        //                         //
        //     Public attributes    //
        //                         //
        /////////////////////////////

        /**
         * The current input language.
         * Used by react components to display widget content in the right language depending on the lang defined in
         * designer.
         * @type {string}
         */
        vm.inputLang = Translation.getInputLanguage();

        /////////////////////////////

        /////////////////////////////
        //                         //
        //     Private functions   //
        //                         //
        /////////////////////////////

        /**
         * Compute the list of links from items in properties.
         * Translate the title, link and description and remove non translated links.
         *
         * @param  {Array}   items      The list of links.
         * @param  {boolean} noFallback Whether we should disable fallback.
         * @return {Array}   The filtered list of links with translated properties.
         */
        function computeLinks({ items, noFallback }) {
            const currentLang = noFallback ? Translation.getLang('current') : undefined;
            const lang = Utils.isDesignerMode() ? Translation.inputLanguage : currentLang;

            const links = map(items, (link) => {
                const translatedLink = Translation.translate(link.link, undefined, lang);
                const translatedTitle = Translation.translate(link.title, undefined, lang);
                const translatedDescription = Translation.translate(link.description, undefined, lang);

                return {
                    description: translatedDescription,
                    link: translatedLink,
                    targetBlank: link.targetBlank,
                    thumbnail: link.thumbnail,
                    title: translatedTitle,
                };
            });

            return filter(links, (link) => link.link !== '' && link.title !== '');
        }

        /////////////////////////////
        //                         //
        //     Public functions    //
        //                         //
        /////////////////////////////

        /**
         * Get widget classes.
         *
         * @return {Array} An array of widget css classes.
         */
        function getWidgetClass() {
            const widgetClass = [];

            vm.parentCtrl.getWidgetClass(widgetClass);

            if (vm.isWidgetEmpty()) {
                widgetClass.push('widget--is-empty');
            }

            return widgetClass;
        }


        /** Defines whether the widget is empty or not. */
        function isWidgetEmpty() {
            const { items, noFallback } = vm.widget.properties;

            return computeLinks({ items, noFallback }).length === 0;
        }

        /** Determines whether the widget is hidden or not. */
        function isWidgetHidden() {
            vm.parentCtrl.isHidden = !vm.parentCtrl.designerMode() && !vm.widget.properties.noResults && isWidgetEmpty();

            return vm.parentCtrl.isHidden;
        }

        vm.getWidgetClass = getWidgetClass;
        vm.isWidgetEmpty = isWidgetEmpty;
        vm.isWidgetHidden = isWidgetHidden;

        /////////////////////////////
        //                         //
        //          Events         //
        //                         //
        /////////////////////////////

        /**
         * Reinitialize the list of links when current language has changed.
         * Update the inputLang to trigger a new render of the Widget
         */
        $scope.$on('inputLanguage', function onLanguageChange(evt, inputLang) {
            var currentProperties = _.get(vm.widget, 'properties');
            currentProperties.inputLang = inputLang.lang;
            vm.inputLang = inputLang;
        });

        vm.init = () => {
            if (angular.isUndefined(vm.widget.properties.hasThumbnail)) {
                vm.widget.properties.hasThumbnail = true;
            }
        }

        /////////////////////////////

        /**
         * Set parent controller.
         *
         * @param {Object} parentCtrl Parent controller.
         */
        this.setParentController = function setParentController(parentCtrl) {
            vm.parentCtrl = parentCtrl;
            vm.init();
        };
    }

    /////////////////////////////

    /**
     * The links widget.
     * Display a list of external/internal links in the current language.
     * Each link can have a thumbnail, a title, a description and a target.
     *
     * @param {Object} widget The widget configuration object.
     */

    function widgetLinksDirective() {
        'ngInject';

        function widgetLinksLink(scope, el, attrs, ctrls) {
            ctrls[0].setParentController(ctrls[1]);
        }

        return {
            bindToController: true,
            controller: WidgetLinksController,
            controllerAs: 'vm',
            link: widgetLinksLink,
            replace: true,
            require: ['widgetLinks', '^widget'],
            restrict: 'E',
            scope: {
                widget: '=',
            },
            // eslint-disable-next-line max-len
            templateUrl:
                '/client/front-office/modules/content/modules/widget/modules/widget-links/views/widget-links.html',
        };
    }

    /////////////////////////////

    angular.module('Widgets').directive('widgetLinks', widgetLinksDirective);
})();
